"use strict";
// packages/types/src/release.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReleaseStatus = void 0;
var ReleaseStatus;
(function (ReleaseStatus) {
    ReleaseStatus["DRAFT"] = "draft";
    ReleaseStatus["PENDING_APPROVAL"] = "pending_approval";
    ReleaseStatus["APPROVED"] = "approved";
    ReleaseStatus["REJECTED"] = "rejected";
})(ReleaseStatus || (exports.ReleaseStatus = ReleaseStatus = {}));
